export const parseLiveGameState = (liveGameState) => {
    const defaultTimer = {
        gameTime: undefined,
        direction: undefined
    };
    if (!liveGameState) {
        return defaultTimer;
    }
    if (liveGameState.gameTime && shouldCalculateGameTime(liveGameState.gamePart)) {
        const mileSeconds = Math.ceil(Math.abs(liveGameState.gameTime) * 1000);
        return {
            gameTime: mileSeconds,
            direction: liveGameState.clockDirection === "Stopwatch" ? 1 : 0
        };
    }
    return defaultTimer;
};
const shouldCalculateGameTime = (gamePart = "") => !(gamePart.startsWith("BreakAfter") || gamePart === "Finished");
//# sourceMappingURL=parseLiveGameState.js.map